import { createTheme, Theme } from '@mui/material/styles'

const colors = {
  // Paper & background
  paper: '#ffffff',
  black: '#232019',

  // Primary
  primaryLight: '#FFDE94',
  primaryMain: '#F2C04F',
  primaryDark: '#D59D20',

  // Secondary
  secondaryLight: '#F9B796',
  secondaryMain: '#F7A47C',
  secondaryDark: '#F17D5A',

  // Accent
  accentLight: '#FEFCF7',
  accentMain: '#FDF6E0',
  accentDark: '#F6E9C1',

  // Error
  errorLight: '#ef9a9a',
  errorMain: '#f44336',
  errorDark: '#c62828',

  // Warning
  warningLight: '#fff8e1',
  warningMain: '#ffe57f',
  warningDark: '#ffc107',

  // Grey
  grey100: '#F9F9F9',
  grey200: '#F0F0F0',
  grey300: '#E7E7E7',
  grey400: '#C9C8C8',
  grey600: '#9B9B9B',
  grey700: '#5A5959',
  grey800: '#373735',
  grey900: '#17140D',
}

declare module '@mui/material/styles' {
  interface TypeText {
    dark?: string
  }

  interface PaletteColor {
    200?: string
    800?: string
    900?: string
  }

  interface Palette {
    accent: PaletteColor
  }

  interface PaletteOptions {
    dark?: PaletteColor
    accent?: PaletteColor
  }
}

export default function Palette(): Theme {
  return createTheme({
    palette: {
      common: {
        black: colors.black,
        white: colors.paper,
      },
      primary: {
        light: colors.primaryLight,
        main: colors.primaryMain,
        dark: colors.primaryDark,
        200: colors.primaryLight,
        800: colors.primaryDark,
        contrastText: colors.grey100,
      },
      secondary: {
        light: colors.secondaryLight,
        main: colors.secondaryMain,
        dark: colors.secondaryDark,
        200: colors.secondaryLight,
        800: colors.secondaryDark,
      },
      accent: {
        light: colors.accentLight,
        main: colors.accentMain,
        dark: colors.accentDark,
        contrastText: colors.grey700,
      },
      error: {
        light: colors.errorLight,
        main: colors.errorMain,
        dark: colors.errorDark,
      },
      warning: {
        light: colors.warningLight,
        main: colors.warningMain,
        dark: colors.warningDark,
        contrastText: colors.grey700,
      },
      grey: {
        100: colors.grey100,
        200: colors.grey200,
        300: colors.grey300,
        400: colors.grey400,
        600: colors.grey600,
        700: colors.grey700,
        800: colors.grey800,
        900: colors.grey900,
      },
      text: {
        primary: colors.grey900,
        secondary: colors.grey600,
        dark: colors.grey900,
      },
      divider: colors.grey200,
      background: {
        paper: colors.paper,
        default: colors.paper,
      },
    },
  })
}
